import React from 'react';
import PropTypes from 'prop-types';
import {Container, Typography, Box} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useStyles } from './TopBannerStyles';
import clsx  from 'clsx';

function TopBanner({
	V3,
	type = 'info',
	title = '',
	content = '',
	buttonText = '',
	buttonLink,
	classes
}) {

	return (
		<div className={clsx({[classes.V3]: V3, [classes.bgBlue]: type === 'info'})}>
			<Container component="div" className={classes.bannerContainer}>
				<Box>
					{title ?
						<Typography component="div" className={classes.bannerTitle}>
							{title}
						</Typography> : null
					}
					{content ?
						<Typography component="div" className={classes.bannerContent}>
							{content}
						</Typography> : null
					}
				</Box>
				{buttonText ? 
					<Box className={classes.bannerBtnContainer}>
						<a href={buttonLink} className={classes.bannerBtn}>
							{buttonText}
						</a>
					</Box> : null
				}
			</Container>
		</div>
	);
}

TopBanner.propTypes = {
	classes: PropTypes.object,
	V3: PropTypes.bool,
	type: PropTypes.string,
	title: PropTypes.string,
	content: PropTypes.object,
	buttonText: PropTypes.string,
	buttonLink: PropTypes.string
};

export default withStyles(useStyles)(TopBanner);